import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function EnquiryModal({ open, onClose, productName = "", type = "bulk" }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", company: "", quantity: "", message: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/enquiries", { ...form, type, product_name: productName });
      toast.success("Enquiry sent! Our sales team will contact you shortly.");
      onClose();
      setForm({ name: "", email: "", phone: "", company: "", quantity: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-[#FAF9F6] max-w-md" data-testid="enquiry-modal">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">Bulk Enquiry</DialogTitle>
        </DialogHeader>
        {productName && <p className="text-sm text-muted-foreground">Product: <span className="text-foreground">{productName}</span></p>}
        <form onSubmit={submit} className="flex flex-col gap-3 mt-2">
          <Input required placeholder="Your Name *" value={form.name} onChange={set("name")} data-testid="enquiry-name" className="bg-white" />
          <Input required type="email" placeholder="Email *" value={form.email} onChange={set("email")} data-testid="enquiry-email" className="bg-white" />
          <Input required placeholder="Phone / WhatsApp *" value={form.phone} onChange={set("phone")} data-testid="enquiry-phone" className="bg-white" />
          <Input placeholder="Company Name" value={form.company} onChange={set("company")} data-testid="enquiry-company" className="bg-white" />
          <Input placeholder="Approx. Quantity (e.g. 100 pcs)" value={form.quantity} onChange={set("quantity")} data-testid="enquiry-quantity" className="bg-white" />
          <Textarea placeholder="Your requirements..." value={form.message} onChange={set("message")} data-testid="enquiry-message" className="bg-white" rows={3} />
          <Button type="submit" disabled={loading} className="bg-[#111] text-[#FAF9F6] hover:bg-gold hover:text-[#111] rounded-sm transition-colors duration-300" data-testid="enquiry-submit">
            {loading ? "Sending..." : "Submit Enquiry"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
